import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=41a143c2&"
import script from "./Index.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Index.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports